<app-element-template [element]="element" *ngIf="element.translatedText">
	<span [innerHtml]="element.translatedText"></span>
</app-element-template>
